export default __webpack_public_path__ + "static/media/print_kouji_2.057b45cb.svg";